export default __webpack_public_path__ + "static/media/pokeball_PNG8.65146875.png";